module.exports = __webpack_public_path__ + "media/styles/images/svg/plus-teal-rubric-e30f8d2969ca9b6ce074eed911c671d3.svg";